export default "/images/LászlóDupcsák.jpg?10aad0c83d26398122a57998f7061b07";